export const GET_donor = ({ donor }) => donor;
